import { render, staticRenderFns } from "./Vision.vue?vue&type=template&id=2a336918&scoped=true&"
import script from "./Vision.vue?vue&type=script&lang=ts&"
export * from "./Vision.vue?vue&type=script&lang=ts&"
import style0 from "./Vision.vue?vue&type=style&index=0&id=2a336918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a336918",
  null
  
)

export default component.exports